import { render, staticRenderFns } from "./States.container.vue?vue&type=template&id=60d24fcb&"
import script from "./States.container.vue?vue&type=script&lang=ts&"
export * from "./States.container.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports